export const sourceOfFunds = [
    "Salary",
    "Business profits",
    "Freelance income",
    "Investments",
    "Family support",
    "Inheritance",
    "Property rental/sale",
    "Other"
]


export const sourceOfWealth = [
    "Years of employment",
    "Business ownership",
    "Real estate sales",
    "Long-term investments",
    "Inheritance or family transfer",
    "Other"
]


export const volume = [
    "Under $10,000",
    "$10,000 - $100,000",
    "$100,000 - $500,000",
    "Over $500,000"
]

export const limitVolume = [
    "Less than 20",
    "20 - 100",
    "100 - 500",
    "Over 500"
]


export const professions = [
    "Automotive Sales & Services",
    "Beauty, Cosmetics & Wellbeing",
    "Construction & Maintenance",
    "Arts,Crafts & Creative Design",
    "Digital Marketing,Content Creation & Advertising",
    "Tancial Services (advisory, brokerage, lending)",
    "Retail & E-commerce (own stock)",
    "Dropshipping and Fulfillment Services",
    "Real Estate (agency,property management)",
    "Food & Beverage restaurants,catering,delivery",
    "Health Services (doctors, therapists,pharmacies)",
    "Education and Online Courses",
    "IT and Software Development",
    "Transport and Logistics (taxi, courier, freight)",
    "Agriculture and Farming",
    "Media & Entertainment (film,music,TV)",
    "Non-Profit and Charity Organizations",
    "Consulting (business, legal, compliance)"
]